var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"reveal",attrs:{"id":"USPSmodal","data-reveal":"","data-options":"closeOnClick:false; closeOnEsc:false;"}},[_c('h1',[_vm._v(_vm._s(_vm.time))])])
}
var staticRenderFns = []

export { render, staticRenderFns }